const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/students-olympiad",
  },
  actions: {
    active({ dispatch, state, rootState }, studentId) {
      return dispatch("FETCH", { url: `${state.path}/active?${serialize({ studentId })}`, method: "GET", data: {} }, { root: true });
    },
    start({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/start`, method: "POST", data }, { root: true });
    },
    answer({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/answer`, method: "POST", data }, { root: true });
    },
    skip({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/skip`, method: "POST", data }, { root: true });
    },
    "get-attempt"({ dispatch, state, rootState }, attemptId) {
      return dispatch("FETCH", { url: `${state.path}/attempt/${attemptId}`, method: "GET", data: {} }, { root: true });
    },
  },
};
